export enum ANALYTICS_EVENT_TYPES {
  WEBVIEW_CLOSED = 'webview_closed',
  ADD_CARD_ON_FILE_SUCCESS = 'add_card_on_file_success',
  ADD_CARD_ON_FILE_FAILED = 'add_card_on_file_failed',
  ADD_CARD_ON_FILE_STRIPE_FAILED = 'add_card_on_file_stripe_failed'
}

export enum ANALYTICS_EVENT_NAMES {
  ADD_CARD_ON_FILE_WEBVIEW = 'Add_Card_On_File_Webview'
}
